import MaterialIcon from "../../../../__snowpack__/pkg/@mui/material/Icon.js";
import styled from "styled-components";
export const IconContainer = styled(MaterialIcon).withConfig({
  displayName: "iconstyles__IconContainer",
  componentId: "sc-4lhhwn-0"
})(["", ""], ({
  onClick
}) => onClick ? {
  cursor: "pointer"
} : {
  cursor: "default"
});
